import { Result } from 'antd'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../AuthContext'

/** `/workspace` with no `:workspaceId` — routes a logged-in user to
 * their first (and, this phase, usually only) Workspace membership.
 * A Platform Admin with zero memberships (spec §31: no auto-
 * impersonation) sees an honest empty state, never a silent redirect
 * into someone else's tenant. */
export default function WorkspaceIndexRedirect() {
  const { me } = useAuth()
  const first = me?.workspaces[0]

  if (!first) {
    return (
      <Result
        status="info"
        title="No workspace membership"
        subTitle="This account is not a member of any Workspace yet. Ask a Platform Admin to add you."
      />
    )
  }

  // VISTOERA_CANVAS_AS_PRIMARY_HOME_AND_GLOBAL_ACCOUNT_ENTRY_V1 §4 — the
  // bare `/workspace` entry (post-login default with no explicit deep
  // link, and the top-level `/` redirect) now lands on the Home Canvas,
  // not the old `overview` dashboard page. `overview` itself is
  // untouched and still reachable from the left nav (spec §50/§51 —
  // existing pages are never removed, only DEFAULT ENTRY PRIORITY
  // changes).
  return <Navigate to={`/workspace/${first.workspace_id}/home`} replace />
}
